import { motion } from "framer-motion";

const EnergyBeam = ({ inView, vertical = false }: { inView: boolean; vertical?: boolean }) => {
  if (vertical) {
    return (
      <div className="relative w-1 h-full mx-auto overflow-hidden rounded-full">
        <div className="absolute inset-0 bg-primary/10" />
        <motion.div
          className="absolute left-0 right-0 h-16 rounded-full"
          style={{
            background: "linear-gradient(180deg, transparent, hsl(var(--primary) / 0.6), transparent)",
          }}
          animate={inView ? { top: ["-20%", "120%"] } : {}}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
    );
  }

  return (
    <div className="relative h-1 w-full overflow-hidden rounded-full">
      <div className="absolute inset-0 bg-primary/10" />
      <motion.div
        className="absolute top-0 bottom-0 w-20 rounded-full"
        style={{
          background: "linear-gradient(90deg, transparent, hsl(var(--primary) / 0.6), transparent)",
        }}
        animate={inView ? { left: ["-10%", "110%"] } : {}}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default EnergyBeam;
